module.exports = __webpack_public_path__ + "img/hart_logo.d7b811ad.svg";